<app-calendar [mode]="mode"></app-calendar>
<app-modal-accept-dialog #modalAcceptDialog></app-modal-accept-dialog>
